import React, { useState, useEffect } from "react";
import { useAccountContext } from "../../../contexts/AccountContext";
import { useAuthorizationsContext } from "../../../contexts/AuthorizationsContext";
import { privateFetch } from "../../../utils/apiHelper";
import ToolboxDocumentItem from "../../../components/ToolboxDocumentItem";
import ManageDocument from "../../../modules/managers/ManageDocument";
import { confirmDialog } from "primereact/confirmdialog";
import { CONSTANTS } from "../../../ressources/CONSTANTS";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import Section from "../../../components/Display/Section";

function ToolboxPage({ hidden }) {
  const { authorizationsContext, getScopeFromName, getAuthorizedScopeList } =
    useAuthorizationsContext();
  const { accountContext } = useAccountContext();

  const [documentList, setDocumentList] = useState([]);
  const [documentScopeName, setDocumentScopeName] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [document, setDocument] = useState(null);
  const [documentModuleOpen, setDocumentModuleOpen] = useState(false);

  useEffect(() => {
    fetchToolboxDocumentList();
  }, [authorizationsContext]);

  const fetchToolboxDocumentList = async () => {
    await privateFetch(
      "GET",
      `/cu/${accountContext.id}/toolbox/?scopes=${getAuthorizedScopeList().map((scope) => scope.name)}`
    ).then((res) => {
      if (res) {
        setDocumentList(res);
      }
    });
  };

  // TODO
  const uploadDocument = async (documentForm) => {
    setLoading(true);
    documentForm.append("linked_scope", getScopeFromName(documentScopeName).id);
    await privateFetch(
      "POST",
      `/cu/${accountContext.id}/toolbox/`,
      "Une erreur est survenue lors de l'ajout de document.",
      "Le document a bien été ajoutée.",
      documentForm,
      false,
      true
    ).then(() => {
      setLoading(false);
      setDocumentModuleOpen(false);
      fetchToolboxDocumentList();
    });
  };

  // TODO
  const updateDocument = async (document, documentForm) => {
    setLoading(true);
    await privateFetch(
      "PUT",
      `/cu/${accountContext.id}/document/${document.id}/`,
      "Une erreur est survenue lors de la modification du document.",
      "Le document a bien été modifié.",
      documentForm,
      false,
      true
    ).then(() => {
      setLoading(false);
      setDocumentModuleOpen(false);
      fetchToolboxDocumentList();
    });
  };

  // TOCHECK
  const deleteDocument = async (document) => {
    setLoading(true);
    await privateFetch(
      "DELETE",
      `/cu/${accountContext.id}/document/${document.id}/`,
      "Une erreur est survenue lors de la suppression du document.",
      "Le document a bien été supprimé."
    ).then(() => {
      setLoading(false);
      setDocumentModuleOpen(false);
      fetchToolboxDocumentList();
    });
  };

  const handleDocument = (document) => {
    setDocument(document);
    setDocumentModuleOpen(document);
  };

  const confirmDocumentDeletion = (document) => {
    setDocumentModuleOpen(false);
    confirmDialog({
      message: `Êtes-vous sûr de vouloir supprimer le document ${document.name} ?`,
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Annuler",
      accept: () => deleteDocument(document),
    });
  };

  const mainContent = (
    <div className="h-full overflow-y-scroll">
      <div className="main-content-container">
        {documentList.map((dl) => (
          <Section
            key={dl.key}
            label={`Documents ${dl.label}`}
            labelClassName={`!text-${dl.color}`}
            actions={[
              {
                onClick: () => {
                  setDocument(undefined);
                  setDocumentModuleOpen(true);
                  setDocumentScopeName(dl.key);
                },
                label: "Ajouter un document",
                icon: "pi-plus",
              },
            ]}
          >
            {CONSTANTS.TOOLBOX_DOCUMENTS.map((TD) => (
              <div className="flex flex-col gap-y-3" key={TD.key}>
                <h4>{TD.label}</h4>
                {dl[TD.key].length ? (
                  <div className="flex flex-row flex-wrap gap-x-5 gap-y-5">
                    {dl[TD.key].map((d, i) => (
                      <ToolboxDocumentItem
                        key={i}
                        document={d}
                        onClick={handleDocument}
                      />
                    ))}
                  </div>
                ) : (
                  <span className="empty-section-message">
                    Aucun document à afficher...
                  </span>
                )}
              </div>
            ))}
          </Section>
        ))}
      </div>
    </div>
  );

  return (
    <div className="h-full w-full" hidden={hidden}>
      {/* Header */}
      <BreadCrumb
        items={[
          {
            label: "Boîte à outils",
            isActive: true,
          },
        ]}
      />
      {/* Content */}
      <div className="hidden-scrollbar main-content-wrapper">{mainContent}</div>

      <ManageDocument
        loading={loading}
        document={document}
        options={CONSTANTS.TOOLBOX_DOCUMENTS}
        defaultType="toolbox_library"
        isOpen={documentModuleOpen}
        handleClose={() => setDocumentModuleOpen(false)}
        uploadDocument={uploadDocument}
        updateDocument={(documentForm) =>
          updateDocument(document, documentForm)
        }
        deleteDocument={() => confirmDocumentDeletion(document)}
        isReadWrite
      />
    </div>
  );
}

export default ToolboxPage;
